var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.slice.items.length)?_c('div',_vm._l((_vm.slice.items),function(item,i){return _c('prismic-rich-text',{key:'page-text-slice_'+i,staticClass:"font-default-size page-text",attrs:{"field":item.text_content}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }